import { useTranslation } from 'react-i18next';
import ModalDialog from '../modal-dialog/modal-dialog.component';
import {
  HeaderSecondary,
  Link,
  TextBody,
} from '../typography/typography.styles';
import { Content } from './payment-modal.styles';
import { FlexContainer } from '../flex-container/flex-container.styles';

interface Props {
  onApprove: () => void;
  onClose: () => void;
  isOpen: boolean;
  link: string;
}

const PaymentModal = ({ onClose, onApprove, isOpen, link }: Props) => {
  const { t } = useTranslation();
  return (
    <ModalDialog
      onClose={onClose}
      isOpen={isOpen}
      width='400px'
      displayButtons={false}>
      <HeaderSecondary>{t('payment_leave_this_page')}</HeaderSecondary>
      <Content>
        <TextBody>{t('payment_leave_this_page_description_1')}</TextBody>
        <TextBody>{t('payment_leave_this_page_description_2')}</TextBody>
      </Content>

      <FlexContainer
        $justify='flex-end'
        $mobJustify='center'>
        <Link
          onClick={onApprove}
          target='_blank'
          $color='#0070CC'
          href={link}>
          {`${t('complete_payment')}`} &rarr;
        </Link>
      </FlexContainer>
    </ModalDialog>
  );
};

export default PaymentModal;
